// @flow
import React from 'react';
import { useFormikContext } from 'formik';
import { setFieldValueToGivenStringAndFieldTouchedToTrue } from '@src/formik-utils/utils';

import { ConfirmModal } from '../presentational/modals/ConfirmModal';
import { DEAL_TYPE_BACKEND_NAME, DEAL_TYPE_RENEWAL, RATE_CARD_BACKEND_NAME } from '../../constants';

const DealTypeChangeWarningModal = ({ isOpen, setOpen }) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  return (
    <ConfirmModal
      body="Changing the deal type from Renewal will delete all existing user entered custom discounts, including Global Discount and Metric Level Discounts. Are you sure you want to proceed?"
      cancelButtonText="No, revert my changes!"
      header="Change in Deal Type"
      isOpen={isOpen}
      okButtonText="Yes, proceed"
      onClickHandlerForCancel={async () => {
        // If the user clicks on cancel, revert the deal type to the previous value of Renewal
        await setFieldValue(DEAL_TYPE_BACKEND_NAME, DEAL_TYPE_RENEWAL);
        setOpen(false);
      }}
      onClickHandlerForOK={async () => {
        // If the user confirms, Go Ahead with the existing behaviour of clearing out the RC and asking for a new one
        await setFieldValueToGivenStringAndFieldTouchedToTrue(
          RATE_CARD_BACKEND_NAME,
          '',
          setFieldValue,
          setFieldTouched
        );
        setOpen(false);
      }}
    />
  );
};

export default DealTypeChangeWarningModal;
